import { ClinicalIntegrationDto, OperationType } from "../Models";

export interface ICustomerCareService {
    processClinicalIntegration: (facilityId: number, operationType: OperationType)  => ng.IPromise<any>;
    fetchClinicalIntegrationStatus: (facilityId: number, operationType: OperationType) => ng.IPromise<ClinicalIntegrationDto[]>;
}